import { FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  photoWrapper: (order: 'photo-left' | 'photo-right') => FelaCSSWithCustomSelectors;
  nonPhotoWrapper: FelaCSSWithCustomSelectors;
}

const styles: IStyles = {
  wrapper: {
    width: '100%',
    minHeight: 'fit-content',

    '@container (width > 768px)': {
      borderRadius: 16,
      overflow: 'hidden',
      flexDirection: 'row',
    },
  },

  photoWrapper: (order: 'photo-left' | 'photo-right') => ({
    '@container (width > 768px)': {
      flexBasis: '33%',
      order: order === 'photo-left' ? 0 : 1,
    },
  }),

  nonPhotoWrapper: {
    '@container (width > 768px)': {
      flexBasis: '67%',
    },
  },
};

export default styles;
